export default __webpack_public_path__ + "static/media/640_dummy2016-irishpub01-mobile-de.1afc8d7c.png";